var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.allowPush)?_c('div',{staticStyle:{"position":"absolute","left":"0px","bottom":"0px","z-index":"100","pointer-events":"auto","display":"none"}},[_c('v-btn',{on:{"click":function($event){return _vm.showLocalNotification('Du hast eine Nachricht!', {
    body: 'Lorem ipsum, dolor sit amet...',
    actions: [
      { action: '/410', title: 'Kundenliste' } ],
  });}}},[_vm._v("push")])],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }